import React from 'react';
import PropTypes from 'prop-types';
import cname from './style.module.scss';
import {PlungerTooltip as Tooltip} from '../MicroPipetteImages';
import {
  P2,
  P20,
  P200,
  P1000,
  PLUNGER_STATE,
  PLUNGER_TOOLTIP_TYPE,
} from '../MicroPipette.constants';

let intervalSecondState = null;
const DURATION_TO_SECOND_STOP = 1200;

export function PlungerTooltip(props) {
  const [plungerState, setPlungetState] = React.useState(PLUNGER_STATE.RELEASE);

  const isMixerTooltip = () =>
    props.plungerTooltip === PLUNGER_TOOLTIP_TYPE.MIXER;

  const getPassiveTooltipType = () => {
    if (isMixerTooltip()) {
      return PLUNGER_TOOLTIP_TYPE.STOPPER;
    } else {
      return PLUNGER_TOOLTIP_TYPE.MIXER;
    }
  };

  const clearWait = () => {
    if (intervalSecondState) {
      clearTimeout(intervalSecondState);
      intervalSecondState = null;
    }
  };

  const onMouseDown = () => {
    if (isMixerTooltip()) {
      setPlungetState(PLUNGER_STATE.MIXING);
    } else {
      clearWait();
      setPlungetState(PLUNGER_STATE.FIRST_STOP);
      intervalSecondState = setTimeout(() => {
        setPlungetState(PLUNGER_STATE.SECOND_STOP);
      }, DURATION_TO_SECOND_STOP);
    }
  };

  const onMouseUp = () => {
    clearWait();
    switch (plungerState) {
      case PLUNGER_STATE.MIXING:
        props.onMix(props.elementId);
        break;
      case PLUNGER_STATE.FIRST_STOP:
        props.onFirstStopper(props.elementId);
        break;
      case PLUNGER_STATE.SECOND_STOP:
        props.onSecondStopper(props.elementId);
        break;
      default:
        break;
    }
    setPlungetState(PLUNGER_STATE.RELEASE);
  };

  const onPassiveclick = () => {
    let param = PLUNGER_TOOLTIP_TYPE.MIXER;
    if (isMixerTooltip()) {
      param = PLUNGER_TOOLTIP_TYPE.STOPPER;
    }
    props.togglePlungerTooltip(param);
  };

  return (
    <>
      <div className={cname.passive}>
        <Tooltip
          type={props.type}
          plungerState={PLUNGER_STATE.RELEASE}
          tooltipType={getPassiveTooltipType()}
        />
      </div>
      <div className={cname.active}>
        <Tooltip
          type={props.type}
          plungerState={plungerState}
          tooltipType={props.plungerTooltip}
        />
      </div>
      <span
        role="button"
        tabIndex={0}
        className={cname.activeClickArea}
        onMouseDown={onMouseDown}
        onMouseUp={onMouseUp}
        onKeyPress={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            onMouseDown();
            onMouseUp();
          }
        }}
      />
      <span
        className={cname[`passive_${getPassiveTooltipType()}`]}
        onClick={onPassiveclick}        
        role="button" 
        tabIndex="0"
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            props.onClick;
          }
        }}
      />
    </>
  );
}

PlungerTooltip.propTypes = {
  /**
   * Type of MicroPipette
   */
  type: PropTypes.oneOf([P2, P20, P200, P1000]),
  /**
   * Unique Id of element Pipette is interacting with
   */
  elementId: PropTypes.number,
  /**
   *  Plunget Tooltip set as current
   */
  plungerTooltip: PropTypes.oneOf([
    PLUNGER_TOOLTIP_TYPE.MIXER,
    PLUNGER_TOOLTIP_TYPE.STOPPER,
  ]),
  /**
   * Funtion to toggle currentPlungerTooltip
   */
  togglePlungerTooltip: PropTypes.func,
  /**
   * Callback function for First Stopper Press
   */
  onFirstStopper: PropTypes.func,
  /**
   * Callback function for Second Stopper Press
   */
  onSecondStopper: PropTypes.func,
  /**
   * Callback function for Mixer Operation
   */
  onMix: PropTypes.func,
};

PlungerTooltip.defaultProps = {};
